import React from "react"
import propTypes from "prop-types"

import { ChevronLeftOutline as Left } from "@styled-icons/evaicons-outline/ChevronLeftOutline"
import { ChevronRightOutline as Right } from "@styled-icons/evaicons-outline/ChevronRightOutline"

import { Wrapper, Switch, Page, PaginationLink } from "./styled"
import { useState } from "react"

const Pagination = ({
  isFirst,
  isLast,
  currentPage,
  numPages,
  prevPage,
  nextPage,
  url,
}) => {
  const [newCurrentPage, setNewCurrentPage] = useState(currentPage)

  const pages = []
  for (let i = 0; i < numPages; i++) {
    const path = i + 1 === 1 ? "/posts" : `/posts/${url}/${i + 1}`
    pages.push(
      <Page key={path} href={path} onClick={() => setNewCurrentPage(i + 1)}>
        {i + 1}
      </Page>
    )
  }

  return (
    <>
      {numPages > 1 && (
        <Wrapper>
          {!isFirst && (
            <PaginationLink href={prevPage}>
              <Left />
            </PaginationLink>
          )}
          <Switch currentPage={newCurrentPage}>{pages}</Switch>
          {!isLast && (
            <PaginationLink href={nextPage}>
              <Right />
            </PaginationLink>
          )}
        </Wrapper>
      )}
    </>
  )
}

Pagination.propTypes = {
  isFirst: propTypes.bool.isRequired,
  isLast: propTypes.bool.isRequired,
  currentPage: propTypes.number.isRequired,
  numPages: propTypes.number.isRequired,
  prevPage: propTypes.string.isRequired,
  nextPage: propTypes.string.isRequired,
}

export default Pagination
